import JobEmployeeForm from "../form";
import { EvtHeader } from "components/header";
import { useNavigate, useParams } from "react-router-dom";


export default function AddJobEmployee(){
     const { jobId, employeeId } = useParams();
      const navigate = useNavigate();
    
      function handleSuccess() {
        navigate(-1);
      }
    return <div className="flex-1">
      <EvtHeader title="Add Employee in Job" />
      <div className="p-6 max-w-md">
        <JobEmployeeForm
          jobId={jobId}
        employeeId={employeeId}
        onSuccess={handleSuccess}/>
      </div>
    </div>
    
}